import axios from 'axios';
import { IClienteContacto } from '../common/entities/cliente-contacto';
import { ICliente } from '../common/entities/cliente';
import { IDomicilio } from '../common/entities/domicilio';
import PathManagement from '../common/path-management';
import { decryptResponse } from '../security/cryptojs-aes-format.js';
import { CartData } from './cart';
import { LoginData } from '../common/entities/usuarios';
import { CityData } from '../common/entities/provincia';
import { getResponseByUrl, patchResponseByUrl, postResponseByUrl, deleteResponseByUrl } from '../common/xhr';

export default class CatalogueView {
  itemList: ItemList = { itemList: [] };
  itemDetail!: ItemDetail;
  recomendedProducts!: RecomendedProducts;
  filter!: Filter;
  order!: Order;
  pagination!: Pagination;
  breadcrumbs: Breadcrumbs = { breadcrumbs: [] };
  cartData!: CartData;
  data!: Data;
  loginData!: LoginData;
  loginRRSSData!: LoginRRSSData;
  checkoutData!: CheckoutData;
  newUserData!: NewUserData;
  districtsData!: DistrictsData;
  cityData!: CityData;
  vinculateRRSSData!: VinculateRRSSData;
  topCarouselData!: TopCarouselData;

  async getItemDetail(detailURL: string): Promise<ItemDetail> {
    let url = detailURL;
    try {
      this.itemDetail = await getResponseByUrl(url);
    } catch (err) {
      console.error(err, 'error al intentar recuperar datos del catalogo');
    }

    return this.itemDetail;
  }

  async getRecomendedProducts(id: string): Promise<RecomendedProducts> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getRecomendedProducts(id);
    try {
      this.recomendedProducts = await getResponseByUrl(url);
    } catch (err) {
      console.error(err, 'error al intentar recuperar datos del catalogo');
    }

    return this.recomendedProducts;
  }

  async addToCart(id: string, qty: number, isPlanetPlus: boolean = false): Promise<CartData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getCartUrl();
    let params = { productId: id, quantity: qty, action:'' };
    if (isPlanetPlus) params = { productId: id, quantity: qty, action: 'addPlanetplusArticulo' };

    try {
      
        this.cartData = await patchResponseByUrl<CartData>(url, params);
      
    } catch (err) {
      
      console.error(err, 'error al intentar agregar al carrito');
    }

    return this.cartData;
  }

  async emptyCart(): Promise<CartData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getCartUrl();
    try {
      this.cartData = await deleteResponseByUrl<CartData>(url);
    } catch (err) {
      console.error(err, 'error al intentar agregar al carrito');
    }

    return this.cartData;
  }

  async deleteFromCart(artId: any): Promise<CartData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getCartUrl();
    try {
      this.cartData = await patchResponseByUrl<CartData>(url, { productId: artId, quantity: 0 });
    } catch (err) {
      console.error(err, 'error al intentar agregar al carrito');
    }

    return this.cartData;
  }

  // async getCart(): Promise<CartData> {
  //   let _pathManager = new PathManagement();
  //   let url = _pathManager.getCartUrl();
  //   let defaultXhrTimeout = 5000;
  //   let response = null;

  //   try {
  //     response = await axios.get(url, { withCredentials: true, timeout: defaultXhrTimeout });

  //     this.cartData = response.data;
  //   // this.cartData = decryptResponse(response.data);

  //   } catch (err) {
  //     console.error(err, 'error al intentar obtener el carrito');
  //   }

  //   return this.cartData;
  // }

  async getAPIData(catalogueURL: string): Promise<Data> {
    let url = catalogueURL;

    try {
      this.data = await getResponseByUrl(url);
    } catch (err) {
      console.error(err, 'error al intentar recuperar datos del catalogo');
    }

    return this.data;
  }

  async loginUser(username: string, password: string, token: string): Promise<LoginData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getLoginUrl();
    let defaultXhrTimeout = 5000;
    let response = null;

    try {
      // response = await axios.post(
      //   url,
      //   { userName: username, password: password, token: token },
      //   { withCredentials: true, timeout: defaultXhrTimeout }
      // );

      // this.loginData = response.data;
      // this.loginData = decryptResponse(response.data);

      let dataToPost = { userName: username, password: password, token: token };
      this.loginData = await postResponseByUrl(url, dataToPost);
    } catch (err) {
      console.error(err, 'error al intentar hacer login');
    }

    return this.loginData;
  }

  async loginUserByActivation(email: any, code: any, token: string): Promise<LoginData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getLoginByActivationUrl();
    let defaultXhrTimeout = 5000;
    let response = null;

    try {
      // response = await axios.post(
      //   url,
      //   { email: email, code: code, token: token },
      //   { withCredentials: true, timeout: defaultXhrTimeout }
      // );

      // this.loginData = response.data;
      // this.loginData = decryptResponse(response.data);

      let dataToPost = { email: email, code: code, token: token };
      this.loginData = await postResponseByUrl(url, dataToPost);
    } catch (err) {
      console.error(err, 'error al intentar hacer login');
    }

    return this.loginData;
  }

  // async isLoggedIn(): Promise<LoginData> {
  //   let _pathManager = new PathManagement();
  //   let url = _pathManager.getLoginCheckUrl();
  //   let defaultXhrTimeout = 5000;
  //   let response = null;

  //   try {
  //     response = await axios.get(url, { withCredentials: true, timeout: defaultXhrTimeout });

  //     this.loginData = response.data;
  //     // this.loginData = decryptResponse(response.data);
  //   } catch (err) {
  //     console.error(err, 'error al intentar verificar loggeo del usuario');
  //   }

  //   return this.loginData;
  // }

  // async logoutUser(): Promise<LoginData> {
  //   let _pathManager = new PathManagement();
  //   let url = _pathManager.getLogoutUrl();
  //   let defaultXhrTimeout = 5000;
  //   let response = null;

  //   try {
  //     response = await axios.get(url, { withCredentials: true, timeout: defaultXhrTimeout });

  //     this.loginData = response.data;
  //     // this.loginData = decryptResponse(response.data);
  //   } catch (err) {
  //     console.error(err, 'error al intentar hacer logout');
  //   }

  //   return this.loginData;
  // }

  async loginRRSS(
    rsId: string,
    rsEmail: string,
    rsUserId: string,
    token: string,
    rsToken: string
  ): Promise<LoginRRSSData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getLoginRRSSUrl();
    let defaultXhrTimeout = 5000;
    let response = null;

    try {
      // response = await axios.post(
      //   url,
      //   { rsId: rsId, rsEmail: rsEmail, rsUserId: rsUserId, token: token, rsToken: rsToken },
      //   { withCredentials: true, timeout: defaultXhrTimeout }
      // );

      // this.loginRRSSData = response.data;

      let dataToPost = { rsId: rsId, rsEmail: rsEmail, rsUserId: rsUserId, token: token, rsToken: rsToken };
      this.loginRRSSData = await postResponseByUrl(url, dataToPost);

      // this.loginRRSSData = decryptResponse(response.data);
    } catch (err) {
      console.error(err, 'error al iniciar sesión');
    }

    return this.loginRRSSData;
  }

  async getCheckoutData(dec_id: string): Promise<CheckoutData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getCheckoutUrl() + '?dec_id=' + dec_id;
    try {
      this.checkoutData = await getResponseByUrl(url);
    } catch (err) {
      console.error(err, 'error al intentar recuperar datos de checkout');
    }

    return this.checkoutData;
  }

  async processCheckout(
    contactId: string,
    addressId: string,
    domicilioFacturacionId: string,
    TransportMethod: string,
    ShippingMethod: string,
    OtherTransport: string,
    date: string,
    availableTime: string,
    paymentMethod: string,
    Aclaraciones: string
  ): Promise<CheckoutData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getCheckoutUrl();
    let defaultXhrTimeout = 5000;
    let response = null;

    //transportistaId   y despues //transportistaNombre y método de envío=transportista
    try {
      // response = await axios.post(
      //   url,
      //   {
      //     idContacto: contactId,
      //     idDireccionDeEntrega: addressId,
      //     metodoDeEnvio: ShippingMethod,
      //     transportistaId: TransportMethod,
      //     transportistaNombre: OtherTransport,
      //     fecha: date,
      //     hora: availableTime,
      //     idTipoDePago: paymentMethod,
      //     observaciones: Aclaraciones,
      //   },
      //   { withCredentials: true, timeout: defaultXhrTimeout }
      // );

      // this.checkoutData = response.data;
      // this.checkoutData = decryptResponse(response.data);

      let dataToPost = {
        idContacto: contactId,
        idDireccionDeEntrega: addressId,
        idDireccionDeFacturacion: domicilioFacturacionId,
        metodoDeEnvio: ShippingMethod,
        transportistaId: TransportMethod,
        transportistaNombre: OtherTransport,
        fecha: date,
        hora: availableTime,
        idTipoDePago: paymentMethod,
        observaciones: Aclaraciones,
      };
      this.checkoutData = await postResponseByUrl(url, dataToPost);
    } catch (err) {
      console.error(err, 'error al intentar recuperar datos de checkout');
    }

    return this.checkoutData;
  }

  async patchNewUserData(
    Contact: any,
    Billing: any,
    SelectedContact: string,
    SelectedAddressId: string,
    cli_id: string
  ): Promise<NewUserData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getNewUserUrl();
    let response = null;

    try {
      let dataToPost = {
        nombre: Contact.ContactName,
        email: Contact.ContactEmail,
        telefono: Contact.ContactPhone,
        provinciaContacto: Contact.ContactCity,
        localidadContacto: Contact.ContactDistrict,
        direccionContacto: Contact.ContactAddress,
        dom_piso: Contact.ContactFloor,
        dom_depto: Contact.ContactApartment,
        codigoPostalId: Contact.ContactZip,
        posiva: Contact.ContactIva,
        cuit: Contact.ContactCuit,
        razonSocial: Contact.ContactRazonSocial,
        pro_nombre: Billing.BillingCity,
        cp_localidad: Billing.BillingDistrict,
        cp_dom_calle_y_numero: Billing.BillingAddress,
        cp_id: Billing.BillingZipId,
        contactId: SelectedContact,
        addressId: SelectedAddressId,
        cli_id: cli_id,
      };
      this.newUserData = await patchResponseByUrl(url, dataToPost);

      // this.newUserData = decryptResponse(response.data);
    } catch (err) {
      console.error(err, 'error al guardar datos');
    }

    return this.newUserData;
  }

  async patchNewUserDataREFACTOR(
    MismaDireccionParaFacturacion: boolean,
    clienteContacto: IClienteContacto,
    cliente: ICliente,
    domicilio: IDomicilio,
    domicilioFacturacion: IDomicilio | null = null
  ): Promise<NewUserData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getNewUserUrl();

    try {
      let dataToPost = {
        nombre: clienteContacto.cc_nombre,
        email: clienteContacto.cc_email,
        telefono: clienteContacto.cc_telefono,
        direccionContacto: domicilio.dom_calle_y_numero,
        dom_piso: domicilio.dom_piso,
        dom_depto: domicilio.dom_depto,
        codigoPostalId: domicilio.dom_cpid,
        posiva: cliente.cli_posiva,
        cuit: cliente.cli_cuit,
        razonSocial: cliente.cli_nombre,
        dom_calle_y_numero: domicilio.dom_calle_y_numero,
        cp_id: domicilio.dom_cpid,
        cli_id: clienteContacto.cli_id,
        domicilioFacturacion: domicilioFacturacion,
        mismoDomicilioFacturacion: MismaDireccionParaFacturacion,
      };

      this.newUserData = await patchResponseByUrl<NewUserData>(url, dataToPost);
      // this.newUserData = decryptResponse(response.data);
    } catch (err) {
      console.error(err, 'error al guardar datos');
    }

    return this.newUserData;
  }

  async getDistricts(city: string): Promise<DistrictsData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getDistricts(city);
    try {
      this.districtsData = await getResponseByUrl(url);
    } catch (err) {
      console.error(err, 'error al intentar recuperar datos de las localidades');
    }

    return this.districtsData;
  }

  async getCityData(): Promise<CityData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getCityUrl();
    try {
      this.cityData = await getResponseByUrl(url);
    } catch (err) {
      console.error(err, 'error al intentar recuperar datos de las provincias');
    }

    return this.cityData;
  }

  async vinculateRRSS(
    rsId: string,
    rsUserId: string,
    rsEmail: string,
    rsToken: string
  ): Promise<VinculateRRSSData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getVincularRRSSUrl();
    let response = null;

    try {
      let dataToPost = { rsId: rsId, rsUserId: rsUserId, rsEmail: rsEmail, rsToken: rsToken };
      this.vinculateRRSSData = await patchResponseByUrl<VinculateRRSSData>(url, dataToPost);
    } catch (err) {
      console.error(err, 'error al vincular la cuenta');
    }

    return this.vinculateRRSSData;
  }

  async getTopCarouselData(): Promise<TopCarouselData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getTopCarousel();
    try {
      this.topCarouselData = await getResponseByUrl(url);
    } catch (err) {
      console.error(err, 'error al intentar recuperar datos de las provincias');
    }

    return this.topCarouselData;
  }
}

export interface TopCarouselData {
  topCarouselData: string;
}

export interface VinculateRRSSData {
  vinculateRRSSData: string;
  rsId: string;
  rsUserId: string;
  rsEmail: string;
}

export interface DistrictsData {
  districtsData: string;
}

export interface NewUserData {
  statusCode: number;
  newUserData: string;
}

export interface CheckoutData {
  statusCode: number;
  checkoutData: any;
  importes: any;
  data: any;
}

export interface LoginRRSSData {
  loginRRSSData: string;
  rsId: string;
  rsEmail: string;
  rsUserId: string;
  token: string;
}

export interface Data {
  itemList: ItemData[];
  itemDetail: ItemData[];
  filter: Filter;
  pagination: Pagination;
  breadcrumbs: Breadcrumbs;
  cartData: CartData;
}

export interface ItemList {
  itemList: ItemData[];
}

export interface ItemDetail {
  itemDetail: ItemData;
}

export interface ItemData {
  art_caract_1: string;
  art_caract_2: string;
  art_caract_3: string;
  art_caract_4: string;
  art_caract_5: string;
  art_color: string;
  art_copete: string;
  art_descripcion: string;
  art_marid: string;
  art_tamano: string;
  color_render: string;
  destacado: boolean;
  destacado_leyenda: string;
  disponible: boolean;
  id: string;
  imagen_1_src: string;
  mar_nombre: string;
  mar_orden: string;
  marcaNombre: string;
  mas_vendido: boolean;
  novedad: boolean;
  oferta: boolean;
  precioLista_formatted: string;
  precioOferta_formatted: string;
  precio_x_cantidad: string;
  snippet_key: string;
}

export interface Filter {
  FilterAvail: FilterItem[];
  currentFilters: FilterItem[];
}

export interface FilterItem {
  filterType: string;
  filterField: string;
  filterValue: string;
}

export interface Pagination {
  currentPage: number;
  pageQty: number;
}

export interface Order {
  avail: OrderItem[];
  current: OrderItem;
}

export interface OrderItem {
  name: string;
  field: string;
  asc_direction: boolean;
}

export interface Breadcrumbs {
  breadcrumbs: Breadcrumbs[];
}

export interface RecomendedProducts {
  recomendedProducts: any;
}
